import React,{useEffect,useState, useRef } from 'react';
import Axios from '../../lib/axios/axiosInstance';
import { useParams , useSearchParams,useNavigate } from "react-router-dom";
import SlectInputField from "../SlectInputField";
import { Container, Row, Col, Tab, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as AuthVerify from '../../lib/common';
import { Space, Table } from 'antd';
import Loader from '../Common/loader';
import CustomTable from './CustomTable';
import "./MyReturn.styles.css";

const returnColumns = [
  {
    title: 'Request',
    dataIndex: 'refnum',
    key: 'refnum',
  },
  {
    title: 'Order',
    dataIndex: 'prefnum',
    key: 'prefnum',
  },
  {
    title: 'Requested Date',
    dataIndex: 'trandate',
    render: (_, record) => (
      <>
        {record && record.trandate ? record.trandate.split('T')[0]:""}
      </>
    )
  },
  {
    title: 'Type',
    key: 'requesttype',
    dataIndex: 'requesttype',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
  },
  {
    title: '',
    key: 'action',
    render: (_, record) => (
      <>
        <Link to={`/return-details?refnum=${record.prefnum}&status=return`}>View Order</Link>
      </>
    ),
  },
];

const MyReturn = () => {
  const navigate = useNavigate();
  const [returns, setReturns] = useState(false);

  useEffect(async () => {
      // Get return request list
      // /account/salesreturn
      await Axios.get(`/account/salesreturn`)
      .then(async (data) => {
        if(data.data?.data?.salesreturn){
          setReturns(data.data?.data?.salesreturn);
        }
        else{
          setReturns([])
        }
      });
  }, [])

  return (
    <div className="col-main">
      <div className="my-account">
        <div className="page-title">
          <h2 style={{ paddingTop: "12px" }}>My Returns</h2>
          {/* <p>Loremn osum doky sit conseete,tut ugiscirq elit. Maecenas quis ex elei'end enim eget. eleifeod gwus. Oonec quis condenentum fin bus
                  </p> */}
        </div>
            
          <div className="main">
              <div className="col-main">
                  <div className="shopping-cart-inner">
                      <div className="page-content">
                          <div className="page-content checkout-page">
                              <div className="box-border" style={{margin:"auto",width:"100%",padding:"0"}}>
                                <CustomTable/>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div >
      </div>
    </div>
  );
};

export default MyReturn;
